document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.quiz-options-group').forEach(group => {
    const selectionType = group.getAttribute('data-selection-type');

    group.querySelectorAll('.quiz-option').forEach(option => {
      option.addEventListener('click', () => {
        if (selectionType === 'single') {
          group.querySelectorAll('.quiz-option').forEach(opt => opt.classList.remove('selected'));
          option.classList.add('selected');
        } else if (selectionType === 'multiple') {
          option.classList.toggle('selected');
        }
      });
    });
  });

  document.getElementById('submit-quiz').addEventListener('click', function() {
    const selectedOptions = {};
    document.querySelectorAll('.quiz-options-group').forEach(group => {
      const question = group.getAttribute('data-question');
      const selectedValues = Array.from(group.querySelectorAll('.quiz-option.selected')).map(opt => opt.getAttribute('data-value'));
      selectedOptions[question] = selectedValues.length === 1 ? selectedValues[0] : selectedValues;
    });

    fetch('/collections/all?view=quiz-results', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(selectedOptions)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(products => {
      displayRecommendedProducts(products);
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
      document.getElementById('quiz-results').innerHTML = '<p>There was an error processing your request. Please try again later.</p>';
    });
  });

  function displayRecommendedProducts(products) {
    var resultsContainer = document.getElementById('quiz-results');
    resultsContainer.innerHTML = '';

    products.forEach(product => {
      var productHtml = `<div class="product">
                           <img src="${product.image}" alt="${product.title}">
                           <h3>${product.title}</h3>
                           <p>${product.price}</p>
                         </div>`;
      resultsContainer.innerHTML += productHtml;
    });
  }
});
